import { FC } from 'react';
import { ArrowRightIcon } from '../../common/components/icons/arrow-right-icon.component';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../auth/feature/auth';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';

const BlackButton: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleClick = () => {
    if (isAuthenticated) {
      navigate(ROUTER_LINKS.MANAGEMENT);
    } else {
      navigate(`${ROUTER_LINKS.SIGNUP}?trial=touchpose`);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex mx-auto justify-center items-center gap-[8px] bg-btn-black text-[18px] min-w-[268px] h-[52px] px-[10px] py-[5px] rounded-[32px] text-surface-base font-body text-medium
      transition-all duration-300 hover:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)] hover:bg-btn-black-hover"
    >
      {t('home.downloadFreeTrial')}
      <ArrowRightIcon />
    </button>
  );
};

export default BlackButton;
